// extracted by mini-css-extract-plugin
export default {"input":"styles_input__Uyl9V","error":"styles_error__B7l6O"};